import { forwardRef, type InputHTMLAttributes } from 'react'
import { clsx } from 'clsx'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ label, error, className, id, ...props }, ref) => {
  const inputId = id ?? props.name
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={inputId} className="text-xs font-semibold text-muted">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        className={clsx(
          'min-h-10 rounded-lg border border-line bg-panel-2 px-2.5 py-2.5 text-text outline-none',
          'focus:border-accent focus:ring-2 focus:ring-accent/20',
          error && 'border-danger',
          className,
        )}
        aria-invalid={Boolean(error)}
        aria-describedby={error && inputId ? `${inputId}-error` : undefined}
        {...props}
      />
      {error && (
        <span id={inputId ? `${inputId}-error` : undefined} className="text-xs text-[#ff8d9a]">
          {error}
        </span>
      )}
    </div>
  )
})
Input.displayName = 'Input'
